import { Methods, Response } from 'types/request.ts'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { log } from 'utils/logging.ts'
import { Flow } from 'types/logging.ts'
import { NotificationsServiceContractsUpdatedRequestBody } from '@boltenergy-be/shared'

export const notifyServiceContractsUpdated = async (
  billingContractNumber: string,
  body: NotificationsServiceContractsUpdatedRequestBody
): Promise<Response> => {
  try {
    const res = await newRequest(
      getAxiosRequestConfigBoltBackend(
        Methods.POST,
        `/notifications/billing-contracts/${billingContractNumber}/service-contracts-updated`,
        body
      )
    )

    if (!res.success) {
      log({
        error: res?.message || `unknown error with the service contracts updated notification for contract ${billingContractNumber}`,
        identifier: `[${Flow.TARIFFS}:triggeredSend${res?.errorCode ? `:${res.errorCode}` : ''}]`,
        errorCode: res?.errorCode
      })
    }

    return res
  } catch (error) {
    log({
      error:
        error instanceof Error
          ? error
          : `unknown error with the service contracts updated notification for contract ${billingContractNumber}`,
      identifier: `[${Flow.TARIFFS}:CATCH:triggeredSend]`
    })
    return { success: false }
  }
}
